import React, {useEffect} from "react";
import "./App.scss";
// import Footer from "./components/Footer/Footer";
// import Header from "./components/Header/Header";
import Router from "./router/router";
import i18next from "i18next";
import "./i18n";

function App() {

    useEffect(() => {
        const currentLang = i18next.language || "ja"; 
        document.body.classList.remove("font-en", "font-ja");
        if (currentLang.startsWith("ja")) {
            document.body.classList.add("font-ja");
        } else if (currentLang.startsWith("en")) {
            document.body.classList.add("font-en");
        }
    }, []);
    return (
        <div className="App">
            <Router />
        </div>
    );
}

export default App;
